
import React from "react";
import StatusBadge from "./StatusBadge";

interface UserInfoSectionProps {
  user: any;
  verificationResult: any;
}

const UserInfoSection: React.FC<UserInfoSectionProps> = ({ user, verificationResult }) => {
  return (
    <section>
      <h3 className="text-lg font-medium mb-4">User Information</h3>
      <div className="bg-gray-50 p-4 rounded-md">
        <div className="grid grid-cols-2 gap-2">
          <div className="text-sm text-gray-500">User ID:</div>
          <div className="text-sm font-mono">{user?.id}</div>
          
          <div className="text-sm text-gray-500">Email:</div>
          <div className="text-sm">{user?.email}</div>
          
          <div className="text-sm text-gray-500">Is Admin:</div>
          <div>
            <StatusBadge condition={!!verificationResult?.isAdmin} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default UserInfoSection;
